// SPDX-FileCopyrightText: 2025 Land Baden-Württemberg <InnoLab@stm.bwl.de>
//
// SPDX-License-Identifier: MPL-2.0

const mediaFilesByJobId = new Map();

export function createTranscriptionMediaFileMeta(file) {
  if (!file) return null;

  return {
    name: typeof file.name === 'string' ? file.name : '',
    size: typeof file.size === 'number' ? file.size : null,
    type: typeof file.type === 'string' ? file.type : '',
    lastModified: typeof file.lastModified === 'number' ? file.lastModified : null,
  };
}

export function setTranscriptionMediaFile(jobId, file) {
  if (!jobId || !file) return;
  mediaFilesByJobId.set(jobId, file);
}

export function getTranscriptionMediaFile(jobId) {
  return mediaFilesByJobId.get(jobId) ?? null;
}

export function removeTranscriptionMediaFile(jobId) {
  mediaFilesByJobId.delete(jobId);
}

export function clearTranscriptionMediaFiles() {
  mediaFilesByJobId.clear();
}

export function getMediaFileMismatch(file, expectedMeta) {
  if (!file || !expectedMeta) return '';

  const expectedName = expectedMeta.name || '';
  if (expectedName && file.name !== expectedName) {
    return 'name';
  }

  if (typeof expectedMeta.size === 'number' && typeof file.size === 'number' && file.size !== expectedMeta.size) {
    return 'size';
  }

  return '';
}
